import { useBackendStatus } from "../../hooks/useBackendStatus";
import { cn } from "../../utils/cn";

const DOT_CLS: Record<string, string> = {
  ok: "bg-success",
  degraded: "bg-warning",
  down: "bg-danger",
  checking: "bg-muted-foreground animate-pulse",
};

const LABEL: Record<string, string> = {
  ok: "operational",
  degraded: "degraded",
  down: "down",
  checking: "checking…",
};

export function BackendStatusDot() {
  const { status, latencyMs } = useBackendStatus();
  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground" title={`Backend: ${LABEL[status]}`}>
      <span className={cn("w-2 h-2 rounded-full", DOT_CLS[status])} aria-hidden="true" />
      <span className="font-mono-tight">{LABEL[status]}</span>
      {latencyMs !== null && status === "ok" && (
        <span className="font-mono-tight text-muted-foreground/70">{latencyMs}ms</span>
      )}
    </div>
  );
}
